module.exports = __webpack_public_path__ + "static/img/home-decor-2.249f600c.jpg";